import { PUBLICATIONS_API_PATH, PUBLISHING_API_PATH } from "api/api-constants";
import { serverApi } from "api/api-server-actions";
import { PublicationType, SectionType } from "components/server-types";
import { slices, store } from "store/index";
import { withApiErrorReporting } from "utils/api-errors";

export async function serverCreateLinkedSections(
  sectionId: string,
  count: number,
  title: string,
): Promise<void> {
  return withApiErrorReporting("serverCreateLinkedSections", async () => {
    const response = await serverApi.post(`${PUBLISHING_API_PATH}/linked_sections/`, {
      section_id: sectionId,
      count,
      title,
    });
    const sections = response.data as SectionType[];
    store.dispatch(slices.sections.actions.updateMany(sections));
  });
}

export async function serverPublishDraftPublication(publicationId: string): Promise<void> {
  return withApiErrorReporting("serverPublishDraftPublication", async () => {
    const response = await serverApi.post(`${PUBLICATIONS_API_PATH}/${publicationId}/publish/`, {
      publication_id: publicationId,
    });
    const publication = response.data as PublicationType;
    store.dispatch(slices.publications.actions.updateOne(publication));
  });
}

/** Ensures a draft publication exists for a template section (POST …/publications/ensure_draft/). */
export async function serverEnsureDraftPublication(
  sectionId: string,
): Promise<PublicationType | null> {
  return withApiErrorReporting("serverEnsureDraftPublication", async () => {
    const response = await serverApi.post(`${PUBLICATIONS_API_PATH}/ensure_draft/`, {
      section_id: sectionId,
    });
    if (response.status === 204) {
      return null;
    }
    const publication = response.data as PublicationType;
    store.dispatch(slices.publications.actions.updateOne(publication));
    return publication;
  });
}

export async function serverFetchLatestPublications(sectionId?: string): Promise<void> {
  return withApiErrorReporting("serverFetchLatestPublications", async () => {
    const response = await serverApi.get(`${PUBLICATIONS_API_PATH}/latest/`, {
      params: sectionId ? { section_id: sectionId } : undefined,
    });
    const publications = response.data as PublicationType[];
    store.dispatch(slices.publications.actions.updateMany(publications));
  });
}
